import axios from "axios";
import { LOCAL_CSRF_TOKEN, LOCAL_STORAGE_AUTH_CHECK_KEY } from "~/_legacy/constants/auth";
import { getCookieValue } from "~/_legacy/utils/auth";

// kenny: path 형식은 이미 정해져 있어서 변경할 수 없음
const baseUrl = import.meta.env.VITE_BASE_API_URL;

const axiosInstance = axios.create({
  baseURL: baseUrl,
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  const csrftoken = getCookieValue("csrftoken");
  if (csrftoken) {
    config.headers["X-CSRFToken"] = csrftoken;
  } else {
    config.headers["X-CSRFToken"] = LOCAL_CSRF_TOKEN;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // kenny: 레거시 백엔드에서 401대신 403을 unauthorized로 처리하고 있음
    // 권한 없는 매장 403 은 로그인이 멀쩡하므로 로그아웃시키지 않는다 (FR-AUTH-011).
    // 값은 ~/shared/constants/auth 의 BRANCH_FORBIDDEN_CODE 와 같아야 한다 —
    // _legacy 는 shared 를 import 하지 않는 경계라 문자열로 둔다.
    // FALLBACK: permission 조합 시 code 가 누락될 수 있으므로 URL 패턴도 함께 확인
    const isBranchForbidden =
      error.response?.status === 403 &&
      (error.response?.data?.code === "branch_forbidden" ||
        error.config?.url?.includes("branches/"));

    if (error.response?.status === 403 && !isBranchForbidden) {
      window.localStorage.removeItem(LOCAL_STORAGE_AUTH_CHECK_KEY);
      const currentPath = window.location.pathname + window.location.search;
      window.localStorage.setItem("redirectAfterLogin", currentPath);
      const currentLanguage = window.location.search.split("language=")[1]?.split("&")[0] ?? "ko";
      window.location.href = `/login?language=${currentLanguage}`;
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
